import type { EditorContentVersion } from '../../types';
import { Row, Col, Body, ListBox, P } from '@workramp/ui';
import { RelativeTimeToThresholdText } from '~/features/temporal/components/RelativeTimeToThresholdText';
import { RichTextContent } from '../RichTextContent';
import { filterVersions } from '../../utils';
import { VersionContentWrapper, VersionHistoryWrapper } from './EditorVersionModal.styles';

export interface VersionViewerProps {
  isLoading?: boolean;
  content: string | undefined | null;
  versions: EditorContentVersion[];
  selectedVersion: EditorContentVersion | null;
  onChange: (version: EditorContentVersion) => void;
}

export function VersionViewer({ isLoading, content, versions, selectedVersion, onChange }: VersionViewerProps) {
  const handleSelectionChange = (keys: 'all' | Set<string | number>) => {
    if (keys === 'all') {
      return;
    }

    const newVersion = versions.find((version) => keys.has(version.url));
    if (newVersion) {
      onChange(newVersion);
    }
  };

  const viewableVersions = filterVersions(versions);

  return (
    <Row>
      <Col>
        <VersionContentWrapper>
          {isLoading && <Body level="md">Loading...</Body>}
          {!isLoading && versions.length === 0 && <Body level="md">No Previous Versions Available</Body>}
          {!isLoading && <RichTextContent>{content}</RichTextContent>}
        </VersionContentWrapper>
      </Col>
      <Col xs={3}>
        <VersionHistoryWrapper>
          <ListBox
            selectionMode="single"
            selectedKeys={selectedVersion ? [selectedVersion.url] : []}
            onSelectionChange={handleSelectionChange}
          >
            {viewableVersions.map((version) => (
              <ListBox.Item key={version.url} description={version.updater.displayName} textValue={version.time}>
                <P density="lg" size={1} weight="medium">
                  <RelativeTimeToThresholdText
                    showTime
                    showTooltip={false}
                    date={new Date(version.time).valueOf()}
                    thresholdHours={24}
                  />
                </P>
              </ListBox.Item>
            ))}
          </ListBox>
        </VersionHistoryWrapper>
      </Col>
    </Row>
  );
}
